import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { SettingDefinitionQueryKeys } from "./keys";
import { CreateUpdateSettingDefinition } from "../../models/SettingDefinition/CreateUpdateSettingDefinition";

export default function useSettingDefinitionMutations() {
  const { post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (definition: CreateUpdateSettingDefinition) =>
      post("/settingDefinition", definition),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SettingDefinitionQueryKeys.all(),
      });
    },
  });

  const update = useMutation({
    mutationFn: (definition: CreateUpdateSettingDefinition) =>
      put(`/settingDefinition/${definition.id}`, definition),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SettingDefinitionQueryKeys.all(),
      });
    },
  });

  const remove = useMutation({
    mutationFn: (settingDefinitionId: string) =>
      del(`/settingDefinition/${settingDefinitionId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: SettingDefinitionQueryKeys.all(),
      });
    },
  });

  return {
    create,
    update,
    remove,
  };
}
